export const EXPERIENCE = ["Currently in training", "Less than 1 year", "1–3 years", "3–5 years", "More than 5 years"];

export const TECHNIQUES = [
  { value: "Nano machine hair strokes", hint: "Saturated or pixelated machine strokes" },
  { value: "Manual microblading", hint: "Hand-tool hair strokes" },
  { value: "Powder/ombré brows", hint: "Soft shaded or gradient finish" },
  { value: "Machine shading", hint: "Machine-implanted shading" },
  { value: "Combo/hybrid brows", hint: "The brow technique — strokes combined with shading (not a pigment formulation)" },
  { value: "Lip Blush", hint: "Soft lip color and definition" },
  { value: "Fine Line Tattoo", hint: "Delicate single-needle or fine-line work" },
  { value: "Areola", hint: "Areola and nipple pigmentation" },
  { value: "Eyeliner", hint: "Lash enhancement and eyeliner" },
];

export const GOALS = [
  "Choosing pigments for new brow procedures",
  "Comparing shades and formulations",
  "Understanding pigment ingredients",
  "Getting more value from my existing kit",
  "Exploring considerations for previously tattooed brows",
  "Building my pigment science knowledge",
];

export const EVIDENCE = {
  verified_shade: { label: "Ingredients documented", hint: "A shade-level ingredient or CI list is recorded from the cited source. Not independently re-verified by Ink Genius — confirm against your bottle and lot." },
  partial: { label: "Ingredients partially documented", hint: "Only part of the ingredient list, or a distributor or collection-level listing, is recorded. Verify the remaining components." },
  unverified: { label: "Ingredients not yet verified", hint: "The shade name is recorded, but its ingredients are not yet documented in Ink Genius." },
  name_only: { label: "Ingredients not yet verified", hint: "Only the product name is recorded. Ingredients need verification before ingredient-based guidance is available." },
};

const CODES = "AF AL DZ AD AO AG AR AM AU AT AZ BS BH BD BB BY BE BZ BJ BT BO BA BW BR BN BG BF BI CV KH CM CA CF TD CL CN CO KM CG CD CR CI HR CU CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FJ FI FR GA GM GE DE GH GR GD GT GN GW GY HT HN HK HU IS IN ID IR IQ IE IL IT JM JP JO KZ KE KI KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MR MU MX FM MD MC MN ME MA MZ MM NA NR NP NL NZ NI NE NG KP MK NO OM PK PW PS PA PG PY PE PH PL PT PR QA RO RU RW KN LC VC WS SM ST SA SN RS SC SL SG SK SI SB SO ZA KR SS ES LK SD SR SE CH SY TW TJ TZ TH TL TG TO TT TN TR TM TV UG UA AE GB US UY UZ VU VA VE VN YE ZM ZW".split(" ");

const names = new Intl.DisplayNames(["en"], { type: "region" });
export const COUNTRIES = CODES.map((c) => names.of(c)).sort((a, b) => a.localeCompare(b));
